// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Nunito_ba5569', '__Nunito_Fallback_ba5569'","fontStyle":"normal"},"className":"__className_ba5569"};